import React, {Fragment} from 'react';
import {getElementAttributes} from 'helpers';
import css from './tree.module.scss';

export function Tree(props) {
  return (
    <ul className={css.tree + ' ' + props.className}>
      { props.children }
    </ul>
  );
}

Tree.Item = function Item(props) {
  return (
    <li {...getElementAttributes(props)} className={css('item', props)} />
  );
}

Tree.Sub = function Sub(props) {
  return (
    <div className={[css.sub, props.small && css.small].join(' ')}>
      { props.children }
    </div>
  );
}

Tree.Child = function Child(props) {
  return (
    <li className={css.subLine}>
      { props.children }
    </li>
  );
}
